import { GDFPalletCode } from '../gdf/type';
import { MS_TO_KT } from '../utils/geo';
import { Palette } from './palettes';

export const winds: Palette[] = [
    {
        name: 'Temperature heatmap',
        id: GDFPalletCode.temp_heatmap,
        type: 'gradientBar',
        units: 'C',
        minValue: -90,
        maxValue: 60,
        maxDisplayValue: 50,
        minDisplayValue: -40,
        stops: [
            { color: '#eeeeeeeb', value: -40 },
            { color: '#ffaaffeb', value: -30 },
            { color: '#910991eb', value: -20 },
            { color: '#24186aeb', value: -15 },
            { color: '#554eb1eb', value: -10 },
            { color: '#3e79c6eb', value: -5 },
            { color: '#4bb698eb', value: 0 },
            { color: '#59d049eb', value: 5 },
            { color: '#bee43deb', value: 10 },
            { color: '#ebd735eb', value: 15 },
            { color: '#eaa43eeb', value: 20 },
            { color: '#e56d53eb', value: 25 },
            { color: '#be3066eb', value: 30 },
            { color: '#6b1527ff', value: 40 },
            { color: '#2b0001ff', value: 50 }
        ],
        getValue: (x) => Math.round((x / 255) * 150 - 90)
    },
    {
        name: 'Wind heatmap',
        id: GDFPalletCode.wind_heatmap,
        type: 'gradientBar',
        units: 'kt',
        minValue: 0,
        maxValue: 128 * MS_TO_KT,
        maxDisplayValue: 110,
        minDisplayValue: 0,
        stops: [
            { color: '#52478d6b', value: 0 },
            { color: '#5156b7d1', value: 5 },
            { color: '#3c7fc6d9', value: 10 },
            { color: '#47ada3d9', value: 15 },
            { color: '#4ac755d9', value: 20 },
            { color: '#78d44dd9', value: 25 },
            { color: '#c1e53cd9', value: 30 },
            { color: '#ebe035d9', value: 35 },
            { color: '#eabd38d9', value: 40 },
            { color: '#e99542d9', value: 45 },
            { color: '#e56d53d9', value: 50 },
            { color: '#ce3b6dd9', value: 60 },
            { color: '#ad2a59de', value: 70 },
            { color: '#651419ed', value: 90 },
            { color: '#2b0001ff', value: 110 }
        ],
        getValue: (x) => Math.round((x / 255) * 128 * MS_TO_KT)
    }
];
